/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import Provider from "./src/provider"

export const wrapRootElement = Provider

export const onClientEntry = () => {
  const intercomAppId = process.env.GATSBY_INTERCOM_APP_ID
  if (!intercomAppId || typeof window.Intercom !== "function") return

  window.Intercom("boot", {
    api_base: "https://api-iam.intercom.io",
    app_id: intercomAppId,
  })
}

export const onRouteUpdate = () => {
  if (typeof window.Intercom === "function") {
    window.Intercom("update")
  }
}
